import { render, staticRenderFns } from "./roomPriceLinking.vue?vue&type=template&id=58b6010f&scoped=true&"
import script from "./roomPriceLinking.vue?vue&type=script&lang=js&"
export * from "./roomPriceLinking.vue?vue&type=script&lang=js&"
import style0 from "./roomPriceLinking.vue?vue&type=style&index=0&id=58b6010f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b6010f",
  null
  
)

export default component.exports